<h1 mat-dialog-title >Nuevo cambio de propiedad</h1>
<div mat-dialog-content>
  <form [formGroup]="cambio">
    <p style="color: black; font-weight: bold"  >Escoja una opción:</p><br>
        <mat-radio-group formControlName="tipo">
          <mat-radio-button value="1" >Soy Vendedor</mat-radio-button><br>
          <mat-radio-button value="2" >Soy Comprador</mat-radio-button><br>
          <mat-radio-button value="3" >Soy Intermediario</mat-radio-button><br>
        </mat-radio-group>
    <br>
    <div class="row">
      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Tipo de Trámite</mat-label>
        <select matInput matNativeControl formControlName="tipoTramite" (change)="onTipoTramiteChange()">
          <option label="--Seleccionar--"></option>
          <option value="CAMBIO DE PROPIEDAD TURISMO">Cambio de Propiedad Turismo</option>
          <option value="CAMBIO DE PROPIEDAD VEHICULO INDUSTRIAL">Cambio de Propiedad Vehículo Industrial</option>
          <option value="CAMBIO DE PROPIEDAD VEHICULO ESPECIAL">Cambio de Propiedad Vehículo Especial</option>
          <option value="CAMBIO DE PROPIEDAD MOTOCICLETA">Cambio de Propiedad Motocicleta</option>
          <option value="CAMBIO DE PROPIEDAD CICLOMOTOR">Cambio de Propiedad Ciclomotor</option>
          <option value="Notificación de venta a particular">Notificación Venta Particular</option>
          <option value="NOTIFICACION VENTA TURISMO">Notificación Venta Turismo</option>
          <option value="NOTIFICACION VENTA INDUSTRIAL">Notificación Venta Industrial</option>
          <option value="NOTIFICACION VENTA ESPECIAL">Notificación Venta Especial</option>
          <option value="NOTIFICACION VENTA MOTOCICLETA">Notificación Venta Motocicleta</option>
          <option value="NOTIFICACION VENTA CICLOMOTOR">Notificación Venta Ciclomotor</option>
        </select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Número de pedido</mat-label>
        <input matInput matNativeControl type="text"
               formControlName="numPedido">
      </mat-form-field>
    </div>
    <!-- <mat-checkbox appearance="outline" class="check" matNativeControl formControlName="justificante">Generar justificante</mat-checkbox>-->

  </form>
</div>
<mat-dialog-actions align="end">
  <button mat-button  mat-dialog-close>Cancelar</button>
  <button mat-button   [disabled]="cambio.invalid" [mat-dialog-close]="cambio">Siguiente</button>
</mat-dialog-actions>
